module.exports = __webpack_public_path__ + "img/homekv2-2.8c6f1703.jpg";